import React from 'react'
import Secondproduct4deatils from '../Advertisement/Secondproduct4deatils'

function Supersalearea2() {
    return (
        <div>
            <Secondproduct4deatils/>
        </div>
    )
}

export default Supersalearea2
